
export const PendingWorkInput = [
  { name: 'possiblePoints', label: "Max points to earn", type: 'number', defaultValue: 100 },
  { name: 'earnedPoints', label: "Points student actually earned", type: 'number', defaultValue: 0 },
  { name: 'comments', label: "Comment to the student", type: 'textarea', defaultValue: ''},
  { name: 'notes', label: "Notes to yourself about the assignment", type: 'textarea', defaultValue: ''}
];